import { TextField, Button, FormControl, Grid } from '@mui/material';

import { CustomAutocomplete, LinearLoading } from 'common'

export const StampForm = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormStamps } = Forms
    const { formState, onInputNumberChange, onSelectSearchChange } = FormStamps
    
    const { fetchStamps, fetchSpecificDocumentsStamps } = FetchData
    const { dataStamps } = fetchStamps
    const { loadingFetchSpecificDocumentsStamps } = fetchSpecificDocumentsStamps
    
    const { onSubmitStampsForm, handleClickResetStampsForm } = Actions

    return (
        <>
            <div className='h4 mt-1 mb-1'>
                {formState.idexpensereception > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {loadingFetchSpecificDocumentsStamps && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitStampsForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idstamp">* Timbre</label>
                            <CustomAutocomplete 
                                customId="idstamp"
                                customName="idstamp"
                                customValue={formState.idstamp}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idstamp', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataStamps.map(({ idstamp, stamp }) => ({
                                        value: idstamp,
                                        name: stamp
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                                customRequired={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="quantity">* Cantidad</label>
                            <TextField
                                id="quantity"
                                name="quantity"
                                value={formState.quantity}
                                onChange={onInputNumberChange}
                                size='small'
                                type="number"
                                step="1"
                                min="0"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button
                                style={{background: "#4b4b4c"}}
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                            </Button>
                            &nbsp; &nbsp;
                            <Button 
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                type="button"
                                variant="contained"
                                onClick={handleClickResetStampsForm}
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Limpiar
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
